import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                    text: 'home.title',
                    icon: 'fas fa-home',
                },
                acl: {
                    view: 'COSEC_00019',
                },
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: 'settings.titles',
                    icon: 'fas fa-cogs',
                },
                acl: {
                    view                    : 'COSEC_00027',
                    edit                    : 'COSEC_00028',
                },
                url: {
                    getConfig               : `/${codeAPI}/gestao/definitions`,
                },
            },
            default_layers: {
                menu: {
                    route: `${code}.default_layers`,
                    text: 'default_layers.titles',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'COSEC_00034',
                    detail                  : 'COSEC_00035',
                    add                     : 'COSEC_00036',
                    edit                    : 'COSEC_00037',
                    delete                  : 'COSEC_00038',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/defaultlayers`,
                    getShow                 : `${codeAPI}/gestao/defaultlayers/:id`,
                    getCreate               : `${codeAPI}/gestao/defaultlayers`,
                    getUpdate               : `${codeAPI}/gestao/defaultlayers/:id`,
                    getDelete               : `${codeAPI}/gestao/defaultlayers/:id`,
                    getLists                : `${codeAPI}/gestao/defaultlayers/lists`,
                    getResources            : `${codeAPI}/gestao/defaultlayers/resources`,
                },
            },
            layers: {
                menu: {
                    route: `${code}.layers`,
                    text: 'layers.titles',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'COSEC_00023',
                    detail                  : 'COSEC_00022',
                    add                     : 'COSEC_00020',
                    edit                    : 'COSEC_00021',
                    delete                  : 'COSEC_00024',
                    private                 : 'COSEC_00003',
                },
                url: {
                    getList: `${codeAPI}/gestao/layers`,
                    getShow: `${codeAPI}/gestao/layers/:id`,
                    getCreate: `${codeAPI}/gestao/layers`,
                    getUpdate: `${codeAPI}/gestao/layers/:id`,
                    getDelete: `${codeAPI}/gestao/layers/:id`,
                    getLists: `${codeAPI}/gestao/layers/lists`,
                    getResources: `${codeAPI}/gestao/layers/resources`,
                    describeResource: `${codeAPI}/gestao/layers/resources/:id/describe`,
                },
            },
            regulations: {
                menu: {
                    route: `${code}.regulations`,
                    text: 'regulations.titles',
                    icon: 'fas fa-book',
                },
                acl: {
                    view                    : 'COSEC_00032',
                    detail                  : 'COSEC_00031',
                    add                     : 'COSEC_00029',
                    edit                    : 'COSEC_00030',
                    delete                  : 'COSEC_00033',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/regulations`,
                    getShow                 : `${codeAPI}/gestao/regulations/:id`,
                    getCreate               : `${codeAPI}/gestao/regulations`,
                    getUpdate               : `${codeAPI}/gestao/regulations/:id`,
                    getDelete               : `${codeAPI}/gestao/regulations/:id`,
                    getLists                : `${codeAPI}/gestao/regulations/lists`,
                },
            },
            print_visible_emissions: {
                menu: {
                    route: `${code}.print_visible_emissions.config`,
                    text: 'print_visible_emissions.titles',
                    icon: 'fas fa-print',
                },
                acl: {
                    view                    : 'COSEC_00025',
                    config                  : 'COSEC_00025',
                    configEdit              : 'COSEC_00026',
                },
                url: {
                    getList                 : `/${codeAPI}/gestao/printvisible`,
                    getConfig               : `/${codeAPI}/gestao/printvisible/settings`,
                    getApps                 : `/${codeAPI}/gestao/printvisible/print/apps`,
                },
            },
        },
        tools: {

        }
    },
};

export default state;